import * as APITypes from "../graphql";

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const customGetLeaderboards =
  /* GraphQL */ `query CustomGetLeaderboards($isMyDepartment: Boolean) {
  getLeaderboards(isMyDepartment: $isMyDepartment) {
      lifetimePoints
      firstName
      lastName
      id
    }
  }
  ` as GeneratedQuery<
    APITypes.GetLeaderboardsQueryVariables,
    APITypes.GetLeaderboardsQuery
  >;
